<template>
  <div class="relative inline-block text-left" ref="menuRef">
    <Menu>
      <div>
        <MenuButton as="template" ref="buttonRef">
          <slot name="button-content" />
        </MenuButton>
      </div>

      <Teleport to="body">
        <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
        >
          <MenuItems
            class="fixed min-w-32 origin-top-right rounded-md bg-bg-canvas shadow-lg focus:outline-none overflow-hidden z-[9999]"
            :class="customWidth ? customWidth : 'w-auto'"
            :style="dropdownStyle"
          >
            <div v-for="(group, index) in actions" :key="index" class="py-0.5">
              <MenuItem
                v-for="(action, idx) in group"
                :key="idx"
                v-slot="{ active }"
                :disabled="action.disabled"
              >
                <button
                  @click="handleActionClick(action)"
                  :class="[
                    action.disabled ? 'cursor-not-allowed opacity-50 bg-grey-4' : '',
                    active ? 'font-semibold' : 'font-medium',
                    'group flex w-full items-center px-2 py-2 text-sm',
                  ]"
                >
                  <Icon :name="action.icon" :stroke-width="2" class="h-4 w-4 mr-2 text-strong" />
                  <p class="whitespace-nowrap font-inter text-strongest">
                    {{ action.label }}
                  </p>
                </button>
              </MenuItem>
            </div>
          </MenuItems>
        </transition>
      </Teleport>
    </Menu>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import { Icon } from "@/components";

const props = defineProps({
  actions: { type: Array, required: true, default: () => [] },
  customWidth: { type: String, default: "" },
});

const emit = defineEmits(["action-click"]);

const menuRef = ref(null);
const buttonRect = ref({ top: 0, right: 0, bottom: 0 });

function updateRect() {
  const el = menuRef.value;
  if (el) {
    const rect = el.getBoundingClientRect();
    buttonRect.value = { top: rect.top, right: rect.right, bottom: rect.bottom };
  }
}

const dropdownStyle = computed(() => ({
  top: `${buttonRect.value.bottom + 8}px`,
  right: `${window.innerWidth - buttonRect.value.right}px`,
}));

let observer;
onMounted(() => {
  updateRect();
  window.addEventListener("scroll", updateRect, true);
  window.addEventListener("resize", updateRect);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", updateRect, true);
  window.removeEventListener("resize", updateRect);
});

const handleActionClick = (action) => {
  if (!action.disabled && action.onClick) {
    action.onClick();
    emit("action-click", action);
  }
};
</script>
